import React from 'react';
import { observer, inject } from 'mobx-react';
import PropTypes from 'prop-types';

import { ChangePassword } from 'apps/profile/settings/tabs/account/changePassword/index';
import { ChangeLanguage } from 'apps/profile/settings/tabs/account/changeLanguage/index';

@inject('routerStore')
@observer
export class AccountSettings extends React.Component {
  render() {
    return (
      <React.Fragment>
        <ChangePassword />
        <ChangeLanguage />
      </React.Fragment>
    );
  }
}

AccountSettings.propTypes = {
  routerStore: PropTypes.object,
};
